import React from "react";
import {mapsUrl} from "../utils/format";
import {MapPinIcon} from "./icons";

/**
 * A street address as shown to the user: a link that opens it in Google Maps,
 * with the map pin before it. Renders nothing for an empty address.
 *
 * `area` (e.g. the city) is added to the Maps search to find the right place,
 * but is not shown.
 *
 * @param {{address?: string|null, area?: string|null}} props
 */
const AddressLink = ({address, area}) => {
    const url = mapsUrl(address, area);
    if (!url) return null;
    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Abrir no Google Maps"
            className="text-decoration-none"
        >
            <span className="me-1">
                <MapPinIcon />
            </span>
            {address}
        </a>
    );
};

export default AddressLink;
